export const chats = {
  chatListChatIfoAttachmentsText: 'Adjunto(s) enviado(s)',
  chatListChatNoMessagesText: 'No hay mensajes aún',
  chatArchivedTitle: 'Chats archivados',
  chatsCreatePrivateCurtainTitle: 'Nuevo chat',
  chatsCreatePrivateCurtaiSearchInputPlaceholder: 'Buscar',
  chatsCreatePrivateCurtainCreateButtonTitle: 'Crear',
  chatCreateButtonTitle: 'Siguiente',
  chatCreateNewGroupHeader: 'Nuevo grupo',
  chatGroupNameInputTitle: 'Nombre del grupo',
  chatLogoTitle: 'Editar',
  chatCreateGroupButtonTitle: 'Crear grupo',
  chatRequiredFieldsAlert: '¡Se debe especificar el nombre del grupo!',
  chatsCreateGroupChatLongTitleAlertText: '¡Por favor, use un título más corto!',
  chatsCreateGroupChatLBigImageAlertText: '¡Por favor, elija una imagen más pequeña!',
  chatsNewChatInputPlaceholder: 'Escribe un mensaje',
  chatsNewChatAddedBigImageAlertText: '¡Por favor, elija una imagen más pequeña!',
  chatOwnersArchiveOptionText: 'Archivar',
  chatOwnersEditGroupOptionText: 'Editar',
  chatOwnersManageGroupOptionText: 'Administrar miembros',
  chatOwnersChangeGroupOptionText: 'Cambiar propietario del grupo',
  chatOwnersLeaveGroupOptionText: 'Salir',
  chatOwnersDeleteGroupOptionText: 'Eliminar chat',
  chatpopupArchivedTitle: 'Archivar chat',
  chatpopupArchivedDescription: '¿Estás seguro?',
  chatArchiveGroupButtonTitleYes: 'Confirmar',
  chatArchiveGroupButtonTitleCancel: 'Cancelar',
  chatEditGroupHeader: 'Editar chat',
  chatEditGroupEditLogoTitle: 'Editar',
  chatEditGroupButtonTitle: 'Guardar',
  chatGroupEditAlertText: '¡Guardado exitosamente!',
  chatManageGroupHeader: 'Administrar',
  chatManageGroupButtonTitle: 'Agregar miembro',
  chatManageGroupSaveButtonTitle: 'Guardar',
  chatAddUsersGroupHeader: 'Agregar miembros',
  chatAddUsersGroupButtonTitle: 'Confirmar',
  chatAddUsersGroupSearchInputPlaceholder: 'Buscar',
  chatOwnershipTransferHeader: 'Transferir propiedad',
  chatOwnershipTransferSearchInputPlaceholder: 'Buscar',
  chatOwnershipTransferButtonTitle: 'Confirmar',
  chatOwnerMarkText: '(tú)',
  chatOwnershipTransferAlertText: '¡Propiedad transferida!',
  chatOwnerLeaveGroupTitle: 'Salir del grupo',
  chatOwnerLeaveGroupDescription: 'Eres propietario del chat, así que debes elegir un nuevo propietario antes de salir del grupo.',
  chatOwnerLeaveGroupButtonTitleYes: 'Elegir',
  chatOwnerLeaveGroupButtonTitleNo: 'Cancelar',
  chatsGroupChatUsersCurtanArchOptionTitle: 'Archivar',
  chatsGroupChatUsersCurtanMembersOptionTitle: 'Miembros del chat',
  chatsGroupChatUsersCurtanLeaveOptionTitle: 'Salir',
  chatsGroupChatMemberCurtainTitle: 'Miembros del chat',
  chatsGroupChatMemberCurtainSearchInputPlaceholder: 'Buscar',
  chatsGroupChatMemberCurtainOwnerMarkText: '(propietario)',
  chatsGroupChatLeavePopupTitle: 'Salir',
  chatsGroupChatLeavePopupText: '¿Estás seguro?',
  chatsGroupChatLeavePopupCancelButtonTitle: 'Cancelar',
  chatsGroupChatLeavePopupConfirmButtonTitle: 'Confirmar',
  chatDeleteGroupTitle: 'Eliminar chat',
  chatDeleteGroupDescription: 'El chat y su historial se eliminarán para todos los participantes, ¿continuar?',
  chatDeleteGroupButtonTitleYes: 'Confirmar',
  chatDeleteGroupButtonTitleNo: 'Cancelar',
  chatsPrivateChatCurtainArchOptionTitle: 'Archivar',
  chatsEditMessage: 'Editar mensaje',
  chatsCopyMessage: 'Copiar mensaje',
  chatsDeleteMessage: 'Eliminar mensaje',
  chatsSelectMessage: 'Seleccionar mensaje',
  chatMarkTextEdit: '(editado)',
  chatCopyMessageAlertText: '¡Mensaje copiado!',
  chatDeleteMessageTitle: 'Eliminar mensaje',
  chatDeleteMessageDescription: '¿Eliminar este mensaje?',
  chatDeleteMessageButtonTitleYes: 'Confirmar',
  chatDeleteMessageButtonTitleNo: 'Cancelar',
  chatSelectButtonDelete: 'Cancelar',
  chatSelectButtonNo: 'Eliminar',
  chatDeleteMessagesTitle: 'Eliminar mensajes',
  chatDeleteMessagesDescription: '¿Eliminar estos mensajes?',
  chatDeleteMessagesButtonTitleYes: 'Confirmar',
  chatDeleteMessagesButtonTitleNo: 'Cancelar',
  chatArchiveButtonRestore: 'Restaurar',
  chatArchiveButtonNo: 'Eliminar',
  chatNoUsersCurtainTitle: '¡Ops!',
  chatsNoUsersCurtainText: 'Parece que no hay otros usuarios además de ti. Invita amigos para comenzar a chatear.',
  chatsNoUsersCurtainCancelButtonTitle: 'Cancelar',
  chatsNoUsersCurtainCopyButtonTitle: 'Copiar enlace de la aplicación',
  chatsAppLinkCopiedAlertText: '¡Enlace copiado!',
  chatsTooFewUsers: '¡Por favor selecciona al menos un usuario para empezar a chatear!',
  chatsError: '¡Algo salió mal!'
}
